<script>
import {Vue} from 'ui.vue';
import "citrus.plugins.form.request";

export default {
	name: 'ProductReviews',
	data: function () {
		return {
			loading: false,
			showAll: false
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("TPL_PRODUCT_REVIEWS_");
		},
		count() {
			return this.arReviews.length;
		},
		showPagination() {
			return this.arReviews.length > 1 && !this.showAll;
		}
	},
	created: function() {

	},
	methods: {
		like(arItem) {
			if(this.loading)
				return;

			this.loading = true;

			this.$request
				.setModeModule(true)
				.setAction('citrus:restsale.api.reviews.like')
				.setData({productId: arItem.ID})
				.send()
				.then((response) => {

					if(false !== response) {
						this.$set(arItem, 'LIKE', response.LIKE);
						this.$set(arItem, 'DISLIKE', response.DISLIKE);
					}

					this.loading = false;
				}, (error) => {
					console.log(error);
					this.loading = false;
				})
		},
		dislike(arItem) {
			if(this.loading)
				return;

			this.loading = true;

			this.$request
				.setModeModule(true)
				.setAction('citrus:restsale.api.reviews.dislike')
				.setData({productId: arItem.ID})
				.send()
				.then((response) => {

					if(false !== response) {
						this.$set(arItem, 'LIKE', response.LIKE);
						this.$set(arItem, 'DISLIKE', response.DISLIKE);
					}

					this.loading = false;
				}, (error) => {
					console.log(error);
					this.loading = false;
				})
		},
		showOtherItems: function() {
			this.showAll = true;
		}
	}
};
</script>